module.exports = __webpack_public_path__ + "static/media/border-none.45db2d7d.svg";